import type { SocialPlatform } from '@/config/marketing-nav.config'
import { cn } from '@/lib/utils'

function SocialIcon({ platform }: { platform: SocialPlatform }) {
  switch (platform) {
    case 'x':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden>
          <path
            d="M11.903 8.465 18.37 1h-1.54l-5.62 6.52L6.58 1H1l6.77 9.87L1 19h1.54l5.93-6.88L13.42 19H19l-7.097-10.535Z"
            fill="currentColor"
          />
        </svg>
      )
    case 'instagram':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden>
          <rect
            x="1.5"
            y="1.5"
            width="17"
            height="17"
            rx="4.5"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <circle cx="10" cy="10" r="4.25" stroke="currentColor" strokeWidth="1.2" />
          <circle cx="14.75" cy="5.25" r="1.1" fill="currentColor" />
        </svg>
      )
    case 'tiktok':
      return (
        <span
          className="marketing-footer__social-icon marketing-footer__social-icon--tiktok"
          aria-hidden
        />
      )
  }
}

export function SocialIconButton({
  platform,
  href,
  label,
  className,
}: {
  platform: SocialPlatform
  href: string
  label: string
  className?: string
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className={cn('marketing-footer__social-btn', className)}
    >
      <SocialIcon platform={platform} />
    </a>
  )
}
